import { Yield } from '../../abacus/interfaces/yield.interface'

export const usageRightYields: Yield[] = [
  {
    label: 'Name',
    property: 'name'
  },
  {
    label: 'Description',
    property: 'description'
  }
]
